/** Blueprint routes from THE MENTOR-LEARNING-Program ARCHITECTURAL MANUAL */

export const ROUTES = {
  LANDING: '/',
  REGISTRATION_PATHWAY: '/registration/pathway',
  REGISTRATION_PRIVATE: '/registration/private',
  REGISTRATION_ORGANISATION: '/registration/organisation',
  CLASSROOM_PORTAL: '/classroom-elt',
  LEARNING_ROOM: '/learning-room-elt',
  EXECUTIVE_INTRO: '/executive-intro',
  STUDENT_SETUP: '/student-setup',
  SYSTEM_ADMIN: '/system-admin',
  MASTER_ADMIN: '/master-admin',
} as const;

export function masterAdminStudentAssessmentPath(studentKey: string): string {
  return `${ROUTES.MASTER_ADMIN}/students/${encodeURIComponent(studentKey)}/assessment`;
}

export type ClassroomRoute = (typeof ROUTES)[keyof typeof ROUTES];

/** Bookmark-friendly route aliases for older paths and PWA entries. */
export const LEGACY_ROUTE_ALIASES: Record<string, ClassroomRoute> = {
  '/register-select': ROUTES.REGISTRATION_PATHWAY,
  '/register-private': ROUTES.REGISTRATION_PRIVATE,
  '/register-org': ROUTES.REGISTRATION_ORGANISATION,
  '/portal-login': ROUTES.CLASSROOM_PORTAL,
  '/classroom-elt': ROUTES.CLASSROOM_PORTAL,
  '/Classroom-elt': ROUTES.CLASSROOM_PORTAL,
  '/introduction': ROUTES.EXECUTIVE_INTRO,
  '/pro-setup': ROUTES.STUDENT_SETUP,
  '/workspace': ROUTES.LEARNING_ROOM,
  '/org-admin': ROUTES.SYSTEM_ADMIN,
};

export function isClassroomPortalRoute(pathname: string): boolean {
  const normalized = pathname.replace(/\/+$/, '').toLowerCase();
  return normalized === '/classroom-elt' || normalized === '/portal-login';
}
